//@import dependencies
import React, { CSSProperties, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
import {DropdownButton, Dropdown} from 'react-bootstrap'
import { CgMenuRound } from 'react-icons/cg'
import { AiOutlineCloseCircle } from 'react-icons/ai'
//@end

//@import config
// import {has_secure} from 'app_config/globals'
//@end

//@import service
import {routingService} from 'app_services/routingService'
//@end

// @import hooks
import useWindowWidth from 'app_hooks/useWindowWidth'
// @end

// @INFO Import Styles
import './../headerPublicCommon.scss'
import DropDownComponent from 'app_components/commons/DropDownComponent/DropDownComponent'
import IconComponent from 'app_components/commons/icons';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'

// @ADD Component types
interface IHeaderPublicCommonLayoutProps {}

const HeaderPublicCommonLayout: React.FC<IHeaderPublicCommonLayoutProps> = () => {

  const [open, updateOpen] = useState<boolean>(false)
  const logoImage = require('app_assets/images/logos/logo.png')
  const logoImageWhite = require('app_assets/images/logos/logo_white.png')

  return(
    <header className="header_public-component">
      <div className='header_public-container'>
        <div className="header-component-1">
          <ItemsHeader1/>
        </div>
        <div className="header-component-2">
          <div className="header-icon">
            <Link className='' to={routingService.getPublicPath()}>
              <img src={logoImage} alt=""/>
            </Link>
          </div>
          <div className="header-empty"></div>
          <div className="container-links-header">
            <div className="header-links">
              <ItemsHeader2/>
            </div>
            <div
              className="menu-button-header"
              onClick={() => updateOpen(true)}
            >
              <CgMenuRound/>
            </div>
            <div
              className={`container-options-movil ${open ? 'open' : 'close'}`}
            >
              <div
                className="close-menu-header"
                onClick={() => updateOpen(false)}
              >
                <AiOutlineCloseCircle/>
              </div>
              <img src={logoImageWhite} alt="" />
              <ItemsHeader1/>
              <hr />
              <ItemsHeader2/>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

// ======================================================
// Items header 1
// ======================================================
interface IItemsHeader1Props {
  className?: string
  style?: CSSProperties

}

const ItemsHeader1: React.FC<IItemsHeader1Props> = (props) => {

  const {t} = useTranslation()
  const {windowWidth} = useWindowWidth()

  return(
    <div
      className={`items_header_1-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      {windowWidth > 767 ?
        <>
          <div className='items-header-1--desktop-container'>
            <Link
              to={'/students'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.students")}</div>
            </Link>
            <Link
              to={'/teachers'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.teachers")}</div>
            </Link>
            <Link
              to={'/business'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.company")}</div>
            </Link>
            <Link
              to="/alliances"
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.alliances")}</div>
            </Link>
            <Link
              to={'/officials'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.employees")}</div>
            </Link>
          </div>
          <Link to='/tutorials'>
            <IconComponent svg='HeaderTutorials' width={20} />
          </Link>
          <Link to={routingService.getSecurePath()}>
            <ButtonComponent variant='tertiary' borderRadius={0} textTransform='initial' paddingTop={11} paddingBottom={11}>
              {t("modules.header.public.links.login")}
            </ButtonComponent>
          </Link>
          <Link to={routingService.getPublicPath("/register")}>
            <ButtonComponent className='header-public--register-button' borderRadius={0}>
              Registrarse
            </ButtonComponent>
          </Link>
        </>
      :
        <DropDownComponent
          title='Soy'
          className='drop-down-header'
          classNameToggle='toogle-dropdown-header'
        >
          <DropDownComponent.Item>
            <div className="header-link font-title-bold disabled">{t("modules.header.public.links.students")}</div>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <Link
              to={'/teachers'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.teachers")}</div>
            </Link>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <Link
              to={'/business'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.company")}</div>
            </Link>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <div className="header-link font-title-bold disabled">{t("modules.header.public.links.community")}</div>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <div className="header-link font-title-bold disabled">{t("modules.header.public.links.graduates")}</div>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <Link
              to="alliances"
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.alliances")}</div>
            </Link>
          </DropDownComponent.Item>
          <DropDownComponent.Item>
            <Link
              to={'/officials'}
            >
              <div className="header-link font-title-bold">{t("modules.header.public.links.employees")}</div>
            </Link>
          </DropDownComponent.Item>
        </DropDownComponent>
      }
    </div>
  );
}


// ======================================================
// Items header 2
// ======================================================
interface IItemsHeader2Props {
  className?: string
  style?: CSSProperties

}

const ItemsHeader2: React.FC<IItemsHeader2Props> = (props) => {

  const {t} = useTranslation()

  return(
    <div
      className={`items_header_2-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <div className="header-link font-text">
        <Link className='' to={routingService.getPublicPath()}>
          {t("modules.header.public.links.home")}
        </Link>
      </div>
      <div className="header-link font-text">
        <DropdownButton
          className="btn-services"
          id="dropdown-basic-button"
          title={t("modules.header.public.links.services.title")}
          alignRight={true}
        >
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion">{t("modules.header.public.links.services.menu.education")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/nuestra-oferta-de-valor/">{t("modules.header.public.links.services.menu.our_value_offer")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/lineas-de-servicio/">{t("modules.header.public.links.services.menu.service_line")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/modalidades/">{t("modules.header.public.links.services.menu.modalities")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/modulares/">{t("modules.header.public.links.services.menu.modular")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/sedes-y-filiales/">{t("modules.header.public.links.services.menu.headquarters_and_subsidiaries")}</Dropdown.Item>
          <Dropdown.Item href="https://www.icontec.org/servicio-educacion/programacion-linea-abierta/">{t("modules.header.public.links.services.menu.open_line_programming")}</Dropdown.Item>
        </DropdownButton>
      </div>
      <div className='heder-public--login-buttons-mobile'>
        <Link to={routingService.getSecurePath()}>
          <ButtonComponent variant='tertiary' width="100%" paddingTop={11} paddingBottom={11}>
            {t("modules.header.public.links.login")}
          </ButtonComponent>
        </Link>
        <Link to={routingService.getPublicPath("/register")}>
          <ButtonComponent className='header-public--register-button' width="100%">
            Registrarse
          </ButtonComponent>
        </Link>
      </div>
    </div>
  );
}


export default HeaderPublicCommonLayout

